module.exports = __webpack_public_path__ + "img/logo.0e53e137.png";